'use client'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useUrlStore } from '@repo/store/useUrlStore'
import { useClientStore } from '@repo/store/useClientStore'
import { useMattersStore } from '@repo/store/useMattersStore'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
import { useUserPreferencesStore } from '@repo/store/useUserPreferencesStore'

// this page is really important.
// the purpose of this page is to have a way to change matter and then redirect to another page.
// It has an Osprey 1 page underneath, so it also updates the current client/matter there
// we need this because not all Osprey 1 pages correctly update the current client/matter when the user navigates to them.
// This page is a workaround to ensure that the current client/matter is updated correctly.

const ChangeMatter = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { isLocal } = useGlobalSettingsStore()
  const { path, urlDecodeClientMatterNo, urlEncodeClientMatterNo } = useUrlStore()
  const { setCurrentClient } = useClientStore()
  const { setCurrentMatter } = useMattersStore()
  const { defaultMatterPage } = useUserPreferencesStore()

  useEffect(() => {
    const wait = (delay) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, delay)
      })
    }

    const handleRedirect = async () => {
      try {
        const { clientMatterNo } = params || {}
        if (!clientMatterNo) throw 'No clientMatterNo found'

        const {
          clientNo,
          matterNo,
          clientMatterNo: decodedClientMatterNo
        } = urlDecodeClientMatterNo({ clientMatterNoParam: clientMatterNo }) || {}

        if (!clientNo) throw 'No clientNo found'
        if (!matterNo && matterNo !== 0 && matterNo !== '0') throw 'No matterNo found'

        setCurrentClient({ clientNo })
        setCurrentMatter({ clientMatterNo: decodedClientMatterNo })

        let queryParams = window.location.hash.split('?')
        if (queryParams?.length > 1) {
          queryParams = queryParams[1].split('&').reduce((acc, item) => {
            const [key, value] = item.split('=')
            acc[key] = value
            return acc
          }, {})
        }

        let targetRoute = queryParams?.redirectTo || defaultMatterPage || `/case-management/matters/matter-workspace`

        if (queryParams?.redirectTo) {
          // wait for iframe to load, but only for a while. Note, we only do this in the redirect path because it isn't needed if we're going to redirect to the matter workspace, which has the same underlying Osprey 1 page as this one
          await wait(500)
        }

        if (!targetRoute) throw 'No target route found'

        if (queryParams?.appendClientMatterNo === true || queryParams?.appendClientMatterNo === 'true') {
          const encodedClientMatterNo = urlEncodeClientMatterNo({ clientMatterNo })
          targetRoute += `/${encodedClientMatterNo}`
        }

        const targetRouteQueryParams = queryParams
          ? Object.keys(queryParams)
              .filter((key) => key !== 'redirectTo' && key !== 'appendClientMatterNo')
              .map((key) => `${key}=${queryParams[key]}`)
          : {}

        if (targetRouteQueryParams?.length) {
          targetRoute += `?${targetRouteQueryParams.join('&')}`
        }

        if (!targetRoute.startsWith('/')) {
          targetRoute = `/${targetRoute}`
        }

        navigate(targetRoute)
      } catch (error) {
        console.error(error)
        navigate(`/case-management/matters/matter-workspace`)
      }
    }

    handleRedirect()
  }, [
    path,
    params,
    navigate,
    setCurrentClient,
    setCurrentMatter,
    isLocal,
    urlDecodeClientMatterNo,
    defaultMatterPage,
    urlEncodeClientMatterNo
  ])

  return null
}

export default ChangeMatter
